import React, { useEffect, useState, useCallback } from "react";
import { collection, getDocs } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { db } from "../../firebase/firebase";

import "../../assets/css/admin/manageGallery.css";
import ImageModal from "../../components/Gallery/ImageModal";
import VideoModal from "../../components/Gallery/VideoModal";

function ManageGallery() {

    const { category } = useParams();

    const [photos, setPhotos] = useState([]);
    const [videos, setVideos] = useState([]);
   const [selectedImage, setSelectedImage] = useState(null);
const [selectedVideo, setSelectedVideo] = useState(null);
   

    const loadGallery = useCallback(async () => {

        try {

            const photoData = [];
            const videoData = [];

            const photoSnapshot = await getDocs(
                collection(db, "photos")
            );

            photoSnapshot.forEach((document) => {

                const item = {
                    id: document.id,
                    ...document.data()
                };

                if (!category || item.category === category) {
                    photoData.push(item);
                }

            });

            const videoSnapshot = await getDocs(
                collection(db, "videos")
            );

            videoSnapshot.forEach((document) => {

                const item = {
                    id: document.id,
                    ...document.data()
                };

                if (!category || item.category === category) {
                    videoData.push(item);
                }

            });

            setPhotos(photoData);
            setVideos(videoData);

        } catch (error) {

            console.log(error);

        }

    }, [category]);

    useEffect(() => {

        loadGallery();

    }, [loadGallery]);

    return (

        <div className="admin-manage-gallery-page">

            {/* =========================
                    PAGE HEADER
            ========================== */}

            <div className="admin-manage-gallery-header">

                <h1>

                    {category ? `${category} Gallery` : "Gallery"}

                </h1>

            </div>

            {/* =========================
                    PHOTOS
            ========================== */}

            <h2 className="admin-manage-gallery-title">

                Photos

            </h2>

            {photos.length === 0 ? (

                <div className="admin-manage-gallery-empty">

                    No Images Found

                </div>

            ) : (

                <div className="admin-manage-gallery-grid">

                    {photos.map((photo) => (

                        <div
                            className="admin-manage-gallery-card"
                            key={photo.id}
                        >

                         <img
    src={photo.imageUrl}
    alt={photo.title}
    className="admin-manage-gallery-image"
    onClick={() => setSelectedImage(photo)}
/>

                            <div className="admin-manage-gallery-content">

                                <h3>

                                    {photo.title}

                                </h3>

                            </div>

                        </div>

                    ))}

                </div>

            )}

            {/* =========================
                    VIDEOS
            ========================== */}

            <h2 className="admin-manage-gallery-title">

                Videos

            </h2>

            {videos.length === 0 ? (

                <div className="admin-manage-gallery-empty">

                    No Videos Found

                </div>

            ) : (

                <div className="admin-manage-gallery-grid">

                    {videos.map((video) => (

                        <div
                            className="admin-manage-gallery-card"
                            key={video.id}
                        >
<video
    className="admin-manage-gallery-video"
    onClick={() => setSelectedVideo(video)}
>

    <source
        src={video.videoUrl}
        type="video/mp4"
    />

</video>

                            <div className="admin-manage-gallery-content">

                                <h3>

                                    {video.title}

                                </h3>

                            </div>

                        </div>

                    ))}

                </div>

            )}
   <ImageModal
    photo={selectedImage}
    onClose={() => setSelectedImage(null)}
/>

<VideoModal
    video={selectedVideo}
    onClose={() => setSelectedVideo(null)}
/>
        </div>

    );

}

export default ManageGallery;